import { FormattedMessage } from 'react-intl'
import { Content, ContentHeader } from 'components/v2/Content'
import Heading from 'components/v2/Heading'
import Card from '@10xLabs/react-web/components/Card'
import { NewAncillary } from 'features/Ancillaries/components/NewAncillaryForm'
import { useMutation } from '@apollo/client'
import { CREATE_ANCILLARY } from 'features/Ancillaries/mutations-legacy'
import { ReactElement } from 'react'
import { useNavigate } from 'react-router'
import { INewAncillaryForm } from 'features/Ancillaries/components/NewAncillaryForm/types'
import { GTLanguage } from 'gql/types.generated'
import { integerToCents } from '@10xlabs/utils'

const NewLuggaeAncillary = (): ReactElement => {
  const navigate = useNavigate()
  const [createAncillary, { loading, error }] = useMutation(CREATE_ANCILLARY, {
    onCompleted: () => {
      navigate('/ancillaries/luggage')
    },
    onError: () => {
      /*Do nothing*/
    }
  })
  const handleSubmit = (values: INewAncillaryForm): void => {
    createAncillary({
      variables: {
        input: {
          name: values.name,
          label: [
            {
              language: GTLanguage.Es,
              text: values.esLabel
            },
            {
              language: GTLanguage.En,
              text: values.enLabel
            }
          ],
          type: values.type,
          price: integerToCents(Number(values.price)),
          companyID: values.company.id,
          conditions: {
            salesChannelIDs: values.salesChannels.map(({ id }) => id)
          }
        }
      }
    })
  }

  return (
    <div>
      <Content hasMaxWidth>
        <ContentHeader>
          <Heading.H3>
            <FormattedMessage id="ancillaries.new.title" defaultMessage="New Ancillary" />
          </Heading.H3>
        </ContentHeader>
        <section>
          <Card.Container>
            <NewAncillary onSubmit={handleSubmit} loading={loading} error={error} />
          </Card.Container>
        </section>
      </Content>
    </div>
  )
}

export default NewLuggaeAncillary
